import type { ActivityModule } from '../../core/activity';
import { mountSmallNumbers } from './ui';
import levelsData from './levels.json';
import '../smallnumbers2/style.css';
import './style.css';

export const smallNumbers: ActivityModule = {
  id: 'smallnumbers',
  title: 'Conte o dado',
  description: 'Conte os pontos do dado antes que ele toque o chão. Versão simples com 1 dado.',
  ageMin: 4,
  ageMax: 8,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/smallnumbers/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountSmallNumbers,
};
